<template>
  <div class="profile-edit">
    <div class="profile-edit__title">
      {{ title }}
    </div>
    <div class="profile-property__list">
      <div v-if="!isCreate && inn !== undefined" class="profile-property__row">
        <div class="profile-property__name">
          {{ inn.name }}
        </div>
        <div class="profile-property__input-wrapper">
          {{ inn.value }}
        </div>
      </div>
      <div class="profile-property__row">
        <div class="profile-property__name">
          {{ getProfileName.name }}
        </div>
        <div class="profile-property__input-wrapper">
          <Common
            :property="getProfileName"
            :validator="v => v.length > 2"
            @onChangeValidation="onChangeValidation"
            @onChangeValue="changeProfileNameHandler"/>
        </div>
      </div>
      <ProfileProperty
        v-for="prop in profileProps"
        :key="prop.id"
        :prop="prop"
        @onChangeValidation="onChangeValidation"/>
    </div>
    <div class="profile-edit__btn-container">
      <div
        class="profile-edit__btn-save"
        :class="{disable: !isValid}"
        @click="onSave">
        Сохранить
      </div>
      <div
        class="profile-edit__btn-cancel"
        @click="onCancel">
        Отмена
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import ProfileProperty from './Inputs/ProfileProperty'
  import Common from './Inputs/Common'

  let validation = {}

  export default {
    name: 'ProfileFormCompany',
    components: {
      ProfileProperty,
      Common
    },
    props: {
      isCreate: {
        type: Boolean,
        default: true
      }
    },
    data: function () {
      return {
        isValid: false
      }
    },
    created: function () {
      validation = {}
    },
    computed: {
      ...mapGetters('profile', [
        'getProfileProps',
        'getProfileName'
      ]),
      profileProps: function () {
        if (this.isCreate) {
          return this.getProfileProps.sort(a => a.code === 'INN' ? -1 : 1)
        } else {
          return this.getProfileProps.filter(e => e.code !== 'INN')
        }
      },
      title: function () {
        if (this.isCreate) {
          return 'Создание профиля юридического лица'
        } else {
          return 'Редактирование профиля юридического лица'
        }
      },
      inn: function () {
        return this.getProfileProps.find(a => a.code === 'INN')
      }
    },
    methods: {
      ...mapMutations('profile', [
        'setProfileName'
      ]),
      ...mapActions('profile', [
        'cancelEdit',
        'saveProfile'
      ]),
      onChangeValidation: function ({code, value}) {
        validation = {
          ...validation,
          [code]: value
        }

        this.isValid = Object.values(validation).reduce((r, c) => r && c, true)
      },
      onSave: function () {
        this.saveProfile()
      },
      onCancel: function () {
        this.cancelEdit()
      },
      changeProfileNameHandler: function (e) {
        this.setProfileName({...this.getProfileName, ...e})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Personal/PersonalProfile/ProfileFormCompany.vue